module.exports = __webpack_public_path__ + "static/media/mail.830d68a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/mail.svg
// module id = 314
// module chunks = 0